import { isEmpty } from 'lodash-es';
import Swal from "sweetalert2";
import Swiper from "swiper";
import ActivityService from "../entrypoints/src/admin/services/activity-service";
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';

import 'swiper/dist/css/swiper.min.css';
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.$addNewDailyProgram = this.element.querySelector('#add-new-daily-program');

    this.$addNewDailyProgram.addEventListener('click', (ev) => {
      ev.preventDefault();
      this.swalAddNewDailyProgram();
    });

    this.initializeSwiper();
  }

  initializeSwiper() {
    new Swiper('.swiper-container', {
      direction: 'horizontal',
      loop: false,
      pagination: {
        el: '.swiper-pagination',
      }
    });
  }

  async swalAddNewDailyProgram() {
    if (!this.activitiesOptions)
      this.activitiesOptions = await this.getActivitiesOptions();

    const { value: activity } = await Swal.fire({
      text: `Adicionar ${this.$addNewDailyProgram.dataset.serviceTerm} para qual Atividade?`,
      input: 'select',
      animation: false,
      inputOptions: this.activitiesOptions,
      inputPlaceholder: 'Selecione a atividade',
      showCancelButton: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          if (isEmpty(value)) {
            resolve('É necessário selecionar uma atividade para continuar')
          } else {
            resolve()
          }
        })
      }
    })

    if (typeof activity !== 'undefined') {
      AjaxLoader.show();
      window.location = this.$addNewDailyProgram.dataset.url.replace('service-id', activity);
    }
  }

  async getActivitiesOptions() {
    if (typeof this.activitiesOptions !== 'undefined')
      return this.activitiesOptions;

    let activities = await ActivityService.all();
    this.activitiesOptions = {};
    activities.forEach((it) => this.activitiesOptions[it.id] = it.name );

    return this.activitiesOptions;
  }
}